// import route from './_helper/route';


import "./header/_header";
import "./shop/_shop";
import "./components/_components";
import "./cart/_cart";
import "./myaccount/_myaccount";
import "./rent/_rent";
import "./checkout/_checkout";
import "./loyaltypoint/_loyaltypoint";
import "./single-product/eventTabClick";
import "./single-product/singleProductTabs";
import "./single-product/addtionalOptionPrice";
import "./home/index";
import "./rent/switchTabAction";

// route.setParam('brand', 'asd')
